import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function ForWhoSection() {
  return <section className="w-full bg-white py-20 px-6 md:px-8" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-80">
          <h2 className="font-serif text-3xl md:text-4xl text-[#1B2141] mb-12 text-center" data-id="element-81">
            Para quién es{' '}
            <span className="text-[#9E8B8B] text-2xl md:text-3xl" data-id="element-82">
              (y para quién no)
            </span>
          </h2>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-83">
            {/* Left Column - Yes */}
            <div className="bg-[#F0F7F4] p-8 rounded-2xl border border-[#6B9E7D]/30" data-id="element-84">
              <h3 className="font-serif text-2xl text-[#2D4A36] mb-6 flex items-center gap-2" data-id="element-85">
                <CheckCircle2 className="w-6 h-6 text-[#6B9E7D]" data-id="element-86" />
                Es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-87">
                {['Eres mujer 65+', 'Te despiertas entre 2–4 AM varias noches por semana', 'Sientes la mente acelerada y quieres algo simple en español', 'Quieres una herramienta discreta, práctica, sin complicarte'].map((item, i) => <li key={i} className="flex items-start text-[#2D2D2D] text-lg" data-id="element-88">
                    <CheckCircle2 className="w-5 h-5 text-[#6B9E7D] mr-3 mt-1 flex-shrink-0" data-id="element-89" />
                    <span data-id="element-90">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Right Column - No */}
            <div className="bg-[#FAF6F6] p-8 rounded-2xl border border-[#9E8B8B]/30" data-id="element-91">
              <h3 className="font-serif text-2xl text-[#5E4B4B] mb-6 flex items-center gap-2" data-id="element-92">
                <XCircle className="w-6 h-6 text-[#9E8B8B]" data-id="element-93" />
                No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-94">
                {['Buscas diagnóstico o tratamiento médico', 'Tienes síntomas severos que requieren evaluación profesional inmediata', 'Quieres “garantías” (nadie serio puede prometer eso)'].map((item, i) => <li key={i} className="flex items-start text-[#5E4B4B] text-lg" data-id="element-95">
                    <div className="w-1.5 h-1.5 rounded-full bg-[#9E8B8B] mr-3 mt-2.5 flex-shrink-0" data-id="element-96"></div>
                    <span data-id="element-97">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}